import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 8h10v8a5 5 0 0 1 -10 0l0 -8","key":"svg-0"}],["path",{"d":"M9 8v-5h6v5","key":"svg-1"}]]

/**
 * IconDeviceUsb
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZGV2aWNlLXVzYiIKPgogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4KICA8cGF0aCBkPSJNNyA4aDEwdjhhNSA1IDAgMCAxIC0xMCAwbDAgLTgiIC8+CiAgPHBhdGggZD0iTTkgOHYtNWg2djUiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/device-usb
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconDeviceUsb = createReactComponent('outline', 'device-usb', 'DeviceUsb', __iconNode);

export default IconDeviceUsb;